import { PageRef } from 'providers/page-ref';

export type TestWorkoutSolverPageParams = {};

export const ITestWorkoutSolverPage: PageRef<TestWorkoutSolverPageParams, void> = {
  pageName: 'TestWorkoutSolverPage',
} as PageRef<TestWorkoutSolverPageParams, void>;
